var _circle, _circle2, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgNnIconFlagsCn = function SvgNnIconFlagsCn(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    viewBox: "0 0 32.2 32.2"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16.1,
    cy: 16.1,
    r: 16,
    fill: "red"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 16.1,
    cy: 16.1,
    r: 16,
    fill: "none",
    stroke: "#BBBCBC",
    strokeMiterlimit: 10,
    strokeWidth: 0.25
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#F6F900",
    d: "m6.7 9.1-1.1 3.5 2.9-2.2 3 2.2-1.2-3.5 3-2.1H9.7L8.5 3.5 7.4 7H3.8zm9.9-5 .6 1.1.1-1.3 1.2-.2-1.1-.5.1-1.2-.8.9-1.1-.5.6 1.1-.8.9zm3.1 3.2.2 1.2.6-1.1 1.2.2-.9-.8.6-1.1-1.1.5-.8-.8.1 1.2-1.1.5zm.8 4-.4-1.1-.3 1.2h-1.2l1 .7-.3 1.1.9-.7 1 .7-.4-1.2 1-.7zm-3.1 2.3-.7 1-1.1-.5.6 1.1-.7.9 1.1-.3.7 1 .1-1.2 1.1-.3-1.1-.5z"
  })));
};
export default SvgNnIconFlagsCn;